import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, MemoryRouter } from "react-router-dom";

import { CaptchaProvider } from "@smart/bridge-captcha-dom";
import { ToastProvider } from "@smart/bridge-intake-components-dom";
import { HistoryProvider } from "@smart/itops-hooks-dom";

import { RouteSelector } from "./routes";

export const IntakeApp = () => (
  <HelmetProvider>
    <BrowserRouter>
      <HistoryProvider>
        <CaptchaProvider>
          <ToastProvider>
            <RouteSelector />
          </ToastProvider>
        </CaptchaProvider>
      </HistoryProvider>
    </BrowserRouter>
  </HelmetProvider>
);

export const IntakeTestingApp = ({
  initialEntries,
}: {
  initialEntries?: string[];
}) => (
  <HelmetProvider>
    <MemoryRouter initialEntries={initialEntries}>
      <ToastProvider>
        <RouteSelector />
      </ToastProvider>
    </MemoryRouter>
  </HelmetProvider>
);
